var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1279_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0621 33.9505L4.10931 23.9977C-1.36391 18.5244 -1.36391 9.59888 4.10931 4.10882C9.59937 -1.3644 18.5249 -1.3644 24.015 4.10882C29.505 9.59888 29.505 18.5244 24.015 23.9977L14.0621 33.9505ZM14.0621 2.02058C10.9803 2.02058 7.89846 3.19942 5.54077 5.54028C3.26728 7.81377 2.02107 10.8451 2.02107 14.0617C2.02107 17.2782 3.26727 20.3096 5.55761 22.583L14.079 31.1044L22.6004 22.583C27.2989 17.8845 27.2989 10.2388 22.6004 5.54028C20.2258 3.19942 17.144 2.02058 14.0621 2.02058Z",
    fill: "#6C6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0623 19.7876C10.8962 19.7876 8.33643 17.211 8.33643 14.0618C8.33643 10.9126 10.913 8.33594 14.0623 8.33594C17.2115 8.33594 19.7881 10.9126 19.7881 14.0618C19.7881 17.211 17.2283 19.7876 14.0623 19.7876ZM14.0623 10.3568C12.0077 10.3568 10.3573 12.024 10.3573 14.0618C10.3573 16.0995 12.0245 17.7667 14.0623 17.7667C16.1 17.7667 17.7672 16.0995 17.7672 14.0618C17.7672 12.024 16.1168 10.3568 14.0623 10.3568Z",
    fill: "#6C6A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_2280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.1239,
    height: 33.9508,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.f01db42cbde37005b08141eaedc64dcb.svg";
export { ForwardRef as ReactComponent };